module.exports = __webpack_public_path__ + "img/LensAdvisors.b752d45f.jpg";